<div class="home-categories" *ngIf="domains.length">
  <div class="home-categories__head">
    <h2 class="home-categories__title">{{ "CLIENT_PAGE.CATEGORIES" | translate }}</h2>
    <button
      type="button"
      class="home-categories__more"
      *ngIf="shouldShowToggle"
      (click)="toggleExpanded()"
    >
      {{
        isExpanded
          ? ("UX_TEXT.HOME_CATEGORIES.SEE_LESS" | translate)
          : ("UX_TEXT.HOME_CATEGORIES.SEE_ALL" | translate)
      }}
      <ion-icon [name]="isExpanded ? 'chevron-up-outline' : 'chevron-forward-outline'"></ion-icon>
    </button>
  </div>

  <div class="home-categories__grid">
    <button
      type="button"
      class="home-categories__card"
      *ngFor="let domain of displayedDomains; trackBy: trackByDomain"
      [@domainItemAnimation]
      (click)="domainSelected.emit(domain)"
    >
      <img class="home-categories__img" [src]="getDomainCardImage(domain)" [alt]="domain.nom" />
      <div class="home-categories__overlay"></div>
      @if (getDomainBadgeImage(domain); as badgeSrc) {
        <span class="home-categories__badge">
          <img class="home-categories__badge-img" [src]="badgeSrc" alt="" />
        </span>
      }
      <h3 class="home-categories__name">{{ domain.nom }}</h3>
    </button>
  </div>

  <div class="home-categories__trust-row" *ngIf="showTrustBadges">
    <div class="home-categories__trust-chip" *ngFor="let badge of trustBadges">
      <span class="home-categories__trust-icon" [ngStyle]="{ color: badge.color }">
        <ion-icon [name]="badge.icon"></ion-icon>
      </span>
      <span class="home-categories__trust-text">{{ badge.textKey | translate }}</span>
    </div>
  </div>
</div>
